import React from 'react'

const UNDERWRITER_STYLES = {
  Allianz: { width: '150px', height: '50px' },
}
const getUnderwriterStyle = (underwriter) => {
  return UNDERWRITER_STYLES[underwriter] || {}
}

const UNDERWRITERS = [
  'Ageas',
  'Allianz',
  'Catlin',
  'Chaucer',
  'Eridge',
  'EridgeSelect',
  'FirstSelect',
  'FirstUnderwriting',
  'Granite',
  'Haven',
  'KGM',
  'Kinetic',
  'LV',
  'Markerstudy',
  'Mulsanne',
  'PenUnderwriting',
  'Service',
  'SomersetBridgeInsuranceServicesLimited',
  'SomersetBridgeLimited',
  'SouthernRock',
  'Towergate',
  'Watford',
] as const

type Underwriter = (typeof UNDERWRITERS)[number]

const UNDERWRITER_LOGO: Record<Underwriter, string> = {
  Ageas: '/images/Underwriters/AgeasLogoForUnderwriterSelection.png',
  Allianz: '/images/Underwriters/AllianzLogoForUnderwriterSelection.png',
  Catlin: '/images/Underwriters/CatlinLogoForUnderwriterSelection.png',
  Chaucer: '/images/Underwriters/ChaucerLogoForUnderwriterSelection.png',
  Eridge: '/images/Underwriters/EridgeLogoForUnderwriterSelection.png',
  EridgeSelect:
    '/images/Underwriters/EridgeSelectLogoForUnderwriterSelection.png',
  FirstSelect:
    '/images/Underwriters/FirstSelectLogoForUnderwriterSelection.png',
  FirstUnderwriting:
    '/images/Underwriters/FirstUnderwritingLogoForUnderwriterSelection.png',
  Granite: '/images/Underwriters/GraniteLogoForUnderwriterSelection.png',
  Haven: '/images/Underwriters/HavenLogoForUnderwriterSelection.png',
  KGM: '/images/Underwriters/KGMLogoForUnderwriterSelection.png',
  Kinetic: '/images/Underwriters/KineticLogoForUnderwriterSelection.png',
  LV: '/images/Underwriters/LVLogoForUnderwriterSelection.png',
  Markerstudy:
    '/images/Underwriters/MarkerstudyLogoForUnderwriterSelection.png',
  Mulsanne: '/images/Underwriters/MulsanneLogoForUnderwriterSelection.png',
  PenUnderwriting:
    '/images/Underwriters/PenUnderwritingLogoForUnderwriterSelection.png',
  Service: '/images/Underwriters/ServiceLogoForUnderwriterSelection.png',
  SomersetBridgeInsuranceServicesLimited:
    '/images/Underwriters/SomersetBridgeInsuranceServicesLimitedLogoForUnderwriterSelection.png',
  SomersetBridgeLimited:
    '/images/Underwriters/SomersetBridgeLimitedLogoForUnderwriterSelection.png',
  SouthernRock:
    '/images/Underwriters/SouthernRockLogoForUnderwriterSelection.png',
  Towergate: '/images/Underwriters/TowergateLogoForUnderwriterSelection.png',
  Watford: '/images/Underwriters/WatfordLogoForUnderwriterSelection.png',
}

export function UnderwriterLogo({ underwriter }: { underwriter: string }) {
  let underwriterName = underwriter
  if (underwriterName === 'Kgm') {
    underwriterName = underwriterName.toUpperCase()
  }
  return (
    <img
      src={`${process.env.PUBLIC_URL}${UNDERWRITER_LOGO[underwriter]}`}
      alt={underwriterName}
      className='price-comparison-underwriter-logo'
      style={getUnderwriterStyle(underwriterName)}
    />
  )
}
